import type { InjectionKey, Ref } from 'vue'
import { useWindowSize } from '@vueuse/core'
import { inject } from 'vue'

/** Set by an app whose window is not its layout box, like the widget iframe. */
export const adaptiveWidthKey: InjectionKey<Readonly<Ref<number>>> = Symbol('adaptive-width')

/** Width that adaptive surfaces compare with their mobile breakpoint. */
export function useAdaptiveWidth() {
  return inject(adaptiveWidthKey, null) ?? useWindowSize().width
}
